export const COUNTRY_CODE_TO_IANA = {
  EG: 'Africa/Cairo',
  SA: 'Asia/Riyadh',
  AE: 'Asia/Dubai',
  KW: 'Asia/Kuwait',
  QA: 'Asia/Qatar',
  BH: 'Asia/Bahrain',
  OM: 'Asia/Muscat',
  JO: 'Asia/Amman',
  LB: 'Asia/Beirut',
  SY: 'Asia/Damascus',
  IQ: 'Asia/Baghdad',
  YE: 'Asia/Aden',
  PS: 'Asia/Gaza',
  LY: 'Africa/Tripoli',
  SD: 'Africa/Khartoum',
  MA: 'Africa/Casablanca',
  DZ: 'Africa/Algiers',
  TN: 'Africa/Tunis',
  MR: 'Africa/Nouakchott',
  SO: 'Africa/Mogadishu',
  DJ: 'Africa/Djibouti',
  KM: 'Indian/Comoro',
  US: 'America/New_York',
  CA: 'America/Toronto',
  GB: 'Europe/London',
  DE: 'Europe/Berlin',
  FR: 'Europe/Paris',
  IT: 'Europe/Rome',
  ES: 'Europe/Madrid',
  NL: 'Europe/Amsterdam',
  BE: 'Europe/Brussels',
  SE: 'Europe/Stockholm',
  NO: 'Europe/Oslo',
  DK: 'Europe/Copenhagen',
  FI: 'Europe/Helsinki',
  PL: 'Europe/Warsaw',
  RO: 'Europe/Bucharest',
  GR: 'Europe/Athens',
  PT: 'Europe/Lisbon',
  IE: 'Europe/Dublin',
  AT: 'Europe/Vienna',
  CH: 'Europe/Zurich',
  TR: 'Europe/Istanbul',
  RU: 'Europe/Moscow',
  UA: 'Europe/Kyiv',
  IN: 'Asia/Kolkata',
  PK: 'Asia/Karachi',
  BD: 'Asia/Dhaka',
  CN: 'Asia/Shanghai',
  JP: 'Asia/Tokyo',
  KR: 'Asia/Seoul',
  MY: 'Asia/Kuala_Lumpur',
  SG: 'Asia/Singapore',
  ID: 'Asia/Jakarta',
  PH: 'Asia/Manila',
  TH: 'Asia/Bangkok',
  VN: 'Asia/Ho_Chi_Minh',
  AU: 'Australia/Sydney',
  NZ: 'Pacific/Auckland',
  ZA: 'Africa/Johannesburg',
  NG: 'Africa/Lagos',
  KE: 'Africa/Nairobi',
  GH: 'Africa/Accra',
  ET: 'Africa/Addis_Ababa',
  BR: 'America/Sao_Paulo',
  AR: 'America/Argentina/Buenos_Aires',
  MX: 'America/Mexico_City',
  CO: 'America/Bogota',
  CL: 'America/Santiago'
};

const COUNTRY_NAME_TO_CODE = {
  Egypt: 'EG',
  'Saudi Arabia': 'SA',
  'United Arab Emirates': 'AE',
  Kuwait: 'KW',
  Qatar: 'QA',
  Bahrain: 'BH',
  Oman: 'OM',
  Jordan: 'JO',
  Lebanon: 'LB',
  Syria: 'SY',
  Iraq: 'IQ',
  Yemen: 'YE',
  Palestine: 'PS',
  Libya: 'LY',
  Sudan: 'SD',
  Morocco: 'MA',
  Algeria: 'DZ',
  Tunisia: 'TN',
  Mauritania: 'MR',
  Somalia: 'SO',
  Djibouti: 'DJ',
  Comoros: 'KM',
  'United States': 'US',
  Canada: 'CA',
  'United Kingdom': 'GB',
  Germany: 'DE',
  France: 'FR',
  Italy: 'IT',
  Spain: 'ES',
  Netherlands: 'NL',
  Belgium: 'BE',
  Sweden: 'SE',
  Norway: 'NO',
  Denmark: 'DK',
  Finland: 'FI',
  Poland: 'PL',
  Romania: 'RO',
  Greece: 'GR',
  Portugal: 'PT',
  Ireland: 'IE',
  Austria: 'AT',
  Switzerland: 'CH',
  Turkey: 'TR',
  Russia: 'RU',
  Ukraine: 'UA',
  India: 'IN',
  Pakistan: 'PK',
  Bangladesh: 'BD',
  China: 'CN',
  Japan: 'JP',
  'South Korea': 'KR',
  Malaysia: 'MY',
  Singapore: 'SG',
  Indonesia: 'ID',
  Philippines: 'PH',
  Thailand: 'TH',
  Vietnam: 'VN',
  Australia: 'AU',
  'New Zealand': 'NZ',
  'South Africa': 'ZA',
  Nigeria: 'NG',
  Kenya: 'KE',
  Ghana: 'GH',
  Ethiopia: 'ET',
  Brazil: 'BR',
  Argentina: 'AR',
  Mexico: 'MX',
  Colombia: 'CO',
  Chile: 'CL'
};

export const resolveCountryCode = ({ countryCode, country } = {}) => {
  const code = String(countryCode || '').trim().toUpperCase();
  if (code && code.length === 2) return code;

  const name = String(country || '').trim();
  if (!name) return '';
  if (COUNTRY_NAME_TO_CODE[name]) return COUNTRY_NAME_TO_CODE[name];
  const lower = name.toLowerCase();
  const match = Object.entries(COUNTRY_NAME_TO_CODE).find(([label]) => label.toLowerCase() === lower);
  return match ? match[1] : '';
};

export const resolveIanaTimezone = ({
  countryCode,
  country,
  timezone,
  businessCountryCode = 'EG'
} = {}) => {
  const explicit = String(timezone || '').trim();
  if (explicit) return explicit;

  const code = resolveCountryCode({ countryCode, country });
  if (code && COUNTRY_CODE_TO_IANA[code]) return COUNTRY_CODE_TO_IANA[code];

  const businessCode = String(businessCountryCode || 'EG').trim().toUpperCase();
  return COUNTRY_CODE_TO_IANA[businessCode] || 'Africa/Cairo';
};

export const shouldUseBusinessFixedOffset = ({
  countryCode,
  country,
  timezone,
  businessCountryCode = 'EG'
} = {}) => {
  if (String(timezone || '').trim()) return false;
  const code = resolveCountryCode({ countryCode, country });
  const businessCode = String(businessCountryCode || 'EG').trim().toUpperCase();
  return !code || code === businessCode;
};

export const formatUtcOffsetLabel = (minutes) => {
  const value = Number(minutes) || 0;
  const sign = value >= 0 ? '+' : '-';
  const abs = Math.abs(value);
  const hours = Math.floor(abs / 60);
  const mins = abs % 60;
  if (!mins) return `UTC${sign}${hours}`;
  return `UTC${sign}${hours}:${String(mins).padStart(2, '0')}`;
};
